module.exports = __webpack_public_path__ + "static/media/rogue.7ae1098c.png";